export const PAGE_SIZE_OPTIONS :number[] = [5, 10, 25, 100];

export const PaginationConfig = {
  perPage: 20,
  page: 1,
  pageSizeOptions: PAGE_SIZE_OPTIONS,
};
